document.addEventListener('DOMContentLoaded', function () {
  function addInitializedClass(swiper) {
    swiper.el.classList.add('initialized');
  }

  function updatePaginationActive(paginationSelector, activeIndex) {
    const bullets = document.querySelectorAll(`${paginationSelector} .swiper-pagination-bullet`);
    bullets.forEach((bullet, index) => {
      bullet.classList.toggle('swiper-pagination-bullet-active', index === activeIndex);
    });
  }

  if (document.querySelector('.collection-list-swiper')) {
    new Swiper('.collection-list-swiper', {
      slidesPerView: 1,
      spaceBetween: 15,
      effect: 'fade',
      autoplay: false,
      loop: false,
      breakpoints: {
        1025: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
      },
      navigation: {
        nextEl: '.collection-swiper .swiper-button-next',
        prevEl: '.collection-swiper .swiper-button-prev',
      },
      pagination: {
        el: '.collection-list-swiper-pagination',
        clickable: true,
        renderBullet: function (index, className) {
          return '<span class="' + className + '">' + (index + 1) + '</span>';
        },
      },
      a11y: {
        enabled: true,
      },
      on: {
        init: function (swiper) {
          addInitializedClass(swiper);
        },
        slideChange: function () {
          updatePaginationActive('.collection-list-swiper-pagination', this.activeIndex);
        },
      },
    });
  }

  // collection-swiper
  if (document.querySelector('.collection-swiper')) {
    new Swiper('.collection-swiper', {
      slidesPerView: 1,
      spaceBetween: 8,
      autoplay: false,
      loop: false,
      navigation: {
        nextEl: '.collection-swiper .swiper-button-next',
        prevEl: '.collection-swiper .swiper-button-prev',
      },
      pagination: {
        el: '.collection-swiper-pagination',
        clickable: true,
        renderBullet: function (index, className) {
          return '<span class="' + className + '">' + (index + 1) + '</span>';
        },
      },
      a11y: {
        slideRole: 'link',
      },
      breakpoints: {
        1025: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
      },
      on: {
        init: function (swiper) {
          addInitializedClass(swiper);
        },
        slideChange: function () {
          updatePaginationActive('.collection-swiper-pagination', this.activeIndex);
        },
      },
    });
  }

  if (document.querySelector('.media-swiper')) {
    new Swiper('.media-swiper', {
      slidesPerView: 1,
      spaceBetween: 0,
      autoplay: false,
      loop: false,
      pagination: {
        el: '.media-swiper-pagination',
        clickable: true,
        renderBullet: function (index, className) {
          return '<span class="' + className + '">' + (index + 1) + '</span>';
        },
      },
      on: {
        init: function (swiper) {
          addInitializedClass(swiper);
        },
        slideChange: function () {
          updatePaginationActive('.media-swiper-pagination', this.activeIndex);
        },
      },
    });
  }

  // review-swiper
  if (document.querySelector('.review-swiper')) {
    new Swiper('.review-swiper', {
      slidesPerView: 1,
      spaceBetween: 15,
      autoplay: false,
      loop: false,
      pagination: {
        el: '.featured-reviews-pagination',
        clickable: true,
        renderBullet: function (index, className) {
          return '<span class="' + className + '">' + (index + 1) + '</span>';
        },
      },
      breakpoints: {
        1440: {
          slidesPerView: 1.35,
          spaceBetween: 20,
        },
      },
      on: {
        init: function (swiper) {
          addInitializedClass(swiper);
        },
        slideChange: function () {
          updatePaginationActive('.featured-reviews-pagination', this.activeIndex);
        },
      },
    });
  }
});
